import model from '@/models/Project'
import {
    GET_LIST,
    GET_SINGLE,
    CREATE,
    UPDATE,
    DELETE
} from '../actions.type'
import {
    SET_LIST,
    SET_SINGLE
} from '../mutations.type'

export const MODULE_NAME = 'PROJECTS'

const initialState = {
    single: null,
    list: []
}

export const state = Object.assign({}, initialState)

const actions = {
    [GET_SINGLE]: ({
        commit
    }, {
        id = null
    }) =>
        new Promise((resolve, reject) => {
            if (id === null) {
                reject(
                    new Error(
                        'Required property id is not set in: projects module, action GET_SINGLE'
                    )
                )
            } else {
                model
                    .getSingle(id)
                    .then(({
                        data
                    }) => {
                        commit(SET_SINGLE, {
                            result: {
                                data
                            }
                        })
                        resolve({
                            data
                        })
                    }).catch(error => {
                        if (error.response && error.response.status && error.response.status === 404) {
                            resolve({
                                data: []
                            })
                        } else {
                            reject(error)
                        }
                    })
            }
        }),
    [CREATE]: ({
        // eslint-disable-next-line no-unused-vars
        dispatch
    }, item) =>
        new Promise((resolve, reject) => {
            if (item === null) {
                reject(
                    new Error(
                        'Required property item is not set in: module user, action SUBMIT'
                    )
                )
            } else {
                model
                    .create(item)
                    .then((
                        data
                    ) => {
                        resolve(
                            data
                        )
                    })
                    .catch(error => {
                        reject(error)
                    })
            }
        }),
    [UPDATE]: ({
        // eslint-disable-next-line no-unused-vars
        dispatch
    }, item) =>
        new Promise((resolve, reject) => {
            if (item === null) {
                reject(
                    new Error(
                        'Required property item is not set in: module user, action SUBMIT'
                    )
                )
            } else {
                model
                    .update(item)
                    .then((
                        data
                    ) => {
                        resolve(
                            data
                        )
                    })
                    .catch(error => {
                        reject(error)
                    })
            }
        }),
    [GET_LIST]: ({
        commit
    }, {
        query = {}
    }) => new Promise((resolve, reject) => {
        return model
            .getList(query)
            .then(({
                data,
                headers
            }) => {
                commit(SET_LIST, {
                    result: {
                        total: parseInt(headers['x-total-count']),
                        data
                    }
                })
                resolve({
                    data,
                    headers
                })
            }).catch(error => {
                if (error.response && error.response.status && error.response.status === 404) {
                    resolve({
                        data: [],
                        headers: {
                            'x-total-count': 0
                        }
                    })
                } else {
                    reject(error)
                }
            })

    }),
    // eslint-disable-next-line no-unused-vars
    [DELETE]: ({ commit }, id = null) =>
        new Promise((resolve, reject) => {
            if (id === null) {
                reject(
                    new Error(
                        'Required property item is not set in: projects module, action DELETE'
                    )
                )
            } else {
                model
                    .delete(id)
                    .then((
                        data
                    ) => {
                        resolve(
                            data
                        )
                    })
                    .catch(error => {
                        reject(error)
                    })
            }
        }),
}

const mutations = {
    [SET_LIST] (state, {
        result
    }) {
        state.list = result
    },
    [SET_SINGLE] (state, {
        result
    }) {
        state.single = JSON.parse(JSON.stringify(result.data))
    }
}

const getters = {
    getList: state => {
        if (state.list) {
            return state.list
        }
        return null
    },
    getSingle: state => {
        if (state.single) {
            return state.single
        }
        return null
    }
}

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
}
